import { WebPage, WithContext } from 'schema-dts';

import SchemaOrg from '@/components/SchemaOrg';
import { useEnvironment } from '@/cutils/context/EnvironmentContext';

import { defaultImage, organization } from './constants';

type GetSearchStructuredDataInput = {
	title: string;
	url: string;
};

export function SearchStructuredData({ title, url }: GetSearchStructuredDataInput) {
	const { constants } = useEnvironment();

	const longTitle = `${title} | ${constants.APP_NAME}`;

	const schema: WithContext<WebPage> = {
		'@context': 'https://schema.org',
		'@type': 'WebPage',
		name: longTitle,
		headline: longTitle,
		url: url,
		mainEntityOfPage: url,
		publisher: organization(constants.SELF_ORIGIN),
		image: defaultImage(constants.SELF_ORIGIN),
		potentialAction: {
			'@type': 'SearchAction',
			target: `${url}?param={search_term_string}`,
			query: 'required name=search_term_string',
		},
	};

	return <SchemaOrg schema={schema} />;
}
